import {
  getDatabase,
  ref,
  onValue,
  off,
  push,
  update,
  remove,
  get,
  child,
} from "firebase/database";

const BASE_PATH = "/projects/validacionTarjetasClub/stores";

const mapSnapshotToArray = (snapshot) => {
  if (!snapshot.exists()) {
    return [];
  }

  const data = snapshot.val();
  return Object.keys(data)
    .map((key) => {
      const item = data[key] || {};

      return {
        id: key,
        nombre: item.nombre || "",
        division:
          typeof item.division === "number"
            ? item.division
            : Number(item.division) || null,
        formato: item.formato || "super-kompras",
        categoria: item.categoria || null,
        actualizadoEn: item.actualizadoEn || null,
        creadoEn: item.creadoEn || null,
      };
    })
    .sort((a, b) => {
      if (a.formato === b.formato) {
        return a.nombre.localeCompare(b.nombre);
      }
      return a.formato.localeCompare(b.formato);
    });
};

export const listenTiendas = (onData, onError) => {
  const db = getDatabase();
  const tiendasRef = ref(db, BASE_PATH);

  const listener = onValue(
    tiendasRef,
    (snapshot) => {
      onData(mapSnapshotToArray(snapshot));
    },
    (error) => {
      if (onError) {
        onError(error);
      }
    }
  );

  return () => {
    off(tiendasRef, "value", listener);
  };
};

export const fetchTiendasOnce = async () => {
  const db = getDatabase();
  const snapshot = await get(child(ref(db), BASE_PATH));
  return mapSnapshotToArray(snapshot);
};

export const createTienda = async (payload) => {
  const db = getDatabase();
  const tiendasRef = ref(db, BASE_PATH);

  const nuevaTienda = {
    nombre: payload.nombre,
    division:
      typeof payload.division === "number"
        ? payload.division
        : Number(payload.division),
    formato: payload.formato,
    categoria: payload.categoria || null,
    creadoEn: Date.now(),
    actualizadoEn: Date.now(),
  };

  const nuevaReferencia = push(tiendasRef);
  await update(nuevaReferencia, nuevaTienda);

  return {
    id: nuevaReferencia.key,
    ...nuevaTienda,
  };
};

export const updateTienda = async (id, payload) => {
  if (!id) {
    throw new Error("Identificador de tienda no proporcionado");
  }

  const db = getDatabase();
  const tiendaRef = ref(db, `${BASE_PATH}/${id}`);

  const cambios = {
    ...payload,
    division:
      typeof payload.division === "number"
        ? payload.division
        : Number(payload.division),
    actualizadoEn: Date.now(),
  };

  await update(tiendaRef, cambios);

  return {
    id,
    ...cambios,
  };
};

export const deleteTienda = async (id) => {
  if (!id) {
    throw new Error("Identificador de tienda no proporcionado");
  }

  const db = getDatabase();
  const tiendaRef = ref(db, `${BASE_PATH}/${id}`);
  await remove(tiendaRef);
};

export const TIENDA_FORMATOS = [
  { value: "super-kompras", label: "Super Kompras" },
  { value: "surtitienda", label: "Surtitienda" },
  { value: "acropolis", label: "Acrópolis" },
];

